import { render, staticRenderFns } from "./BestProducts.vue?vue&type=template&id=22937963"
import script from "./BestProducts.vue?vue&type=script&lang=js"
export * from "./BestProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports